import * as constActions from './objectPageConstActions';
import initialState from './initialState';

export default function objectsPageReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_OBJECT_RELATED_OBJECTS_SUCCESS:
      return Object.assign({}, state, {
        timeLineObjects: action.relatedEntities.TimeLineObjects,
        relatedEntities: action.relatedEntities.DiagramRelatedObjects
      });
    case constActions.GET_OBJECT_TABS_TO_DISPLAY:
      return Object.assign({}, state, {
        tabIdsToDisplay: action.tabIdsToDisplay
      });
    case constActions.SET_OBJECT_TYPE_IDENTIFIER:
      return Object.assign({}, state, {
        EntityType: action.objType,
        EntityIdentifier: action.identifier
      });
    case constActions.GET_OBJECT_PROPERTIES_SUCCESS:
      return Object.assign({}, state, {
        objectProperties: action.objectProperties
      });
    case constActions.GET_STATIC_ANALYSIS_SUCCESS:
      return Object.assign({}, state, {
        staticAnalysisResults: action.staticAnalysisResults
      });
    case constActions.DISPATH_SELECTED_ROWS:
      if (
        state.globalSelectedRows.filter(function (e) {
          return e.entityType == action.tabId;
        }).length > 0
      ) {
        return Object.assign({}, state, {
          globalSelectedRows: state.globalSelectedRows.map((curEntityRows, index) => {
            if (curEntityRows.entityType == action.tabId) {
              return {
                entityType: action.tabId,
                selectedRows: action.selectedRows,
                isSelectAllSelected: action.isSelectAllSelected
              };
            }
            return curEntityRows;
          })
        });
      } else {
        return Object.assign({}, state, {
          globalSelectedRows: [
            ...state.globalSelectedRows,
            {
              entityType: action.tabId,
              selectedRows: action.selectedRows,
              isSelectAllSelected: action.isSelectAllSelected
            }
          ]
        });
      }
    case constActions.DISPATH_SELECTED_TAB:
      return Object.assign({}, state, {
        selectedTab: action.selectedTab
      });
    case constActions.DISPATH_SELECTED_ALERT_ROWS:
      return Object.assign({}, state, {
        chosenAlerts: action.alerts
      });
    case constActions.DISPATH_SELECTED_ALERT_NEW_STATUS:
      return Object.assign({}, state, {
        newAlertsStatus: action.newAlertsStatus
      });
    case constActions.GET_OBJECT_RELATED_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        objectRelatedInformation: action.objectRelatedInformation
      });
    case constActions.GET_REMOTE_IPS_SUCCESS:
      return Object.assign({}, state, {
        remoteIps: action.remoteIps
      });
    case constActions.CHANGE_POLICY_STATUS_SUCCESS:
      return Object.assign({}, state, {
        objectRelatedInformation: action.objectRelatedInformation
      });

    case constActions.SAVE_FILE_GLOBAL_STATE:
      return Object.assign({}, state, {
        fileGlobalState: action.status,
        objectRelatedInformation: Object.assign({}, state.objectRelatedInformation, {
          IsObjectWhiteListed: action.status == 1 ? true : false
        })
      });
    case constActions.SET_CHECKBOX_SEARCH_TABLE_DATA:
      return Object.assign({}, state, {
        hasCheckBoxSearchTableData: action.status
      });
    default:
      return state;
  }
}
